import store from '../..';

export function callString() {
  return store.getters['account/getCurrentClient'].client_name === 'shark'
    ? // Shark
      `{
        group_name,                    
        uuid,
        interface,
        launch_mode,
        ad_schedule,
        club_friendly_name,
        contact_name,
        phone,
        email
        city
        last_activity,
        total_screens,
        version,
        total,
        error,
        success
      }`
    : // Avis Bazzbi
      `{
    group_name,
    uuid,
    interface,
    ad_schedule,
    contact{
      contact_name,
      phone,
      email
    },
    address{
      city
    },
    last_activity,
    error,
    success
  }`;
}

const filterParams = ['interface', 'area_id', 'city', 'ad_schedule', 'status'];

const _filterParams = filterParams;
export { _filterParams as filterParams };
